import { render, staticRenderFns } from "./SweetSpotBasePage.vue?vue&type=template&id=38028429&scoped=true"
import script from "./SweetSpotBasePage.vue?vue&type=script&lang=js"
export * from "./SweetSpotBasePage.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotBasePage.vue?vue&type=style&index=0&id=38028429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38028429",
  null
  
)

export default component.exports